import React, { ButtonHTMLAttributes, forwardRef } from 'react';

import { FontIcons } from '@components/library/icon';
import BaseButton, { ButtonLoaderColors } from '../BaseButton';
import styleClassNames from './styles.module.scss';

interface WarningButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: string | FontIcons;
  iconSize?: number;
  isLoading?: boolean;
  loadingCopy?: string;
  loadingIcon?: string | FontIcons;
  loadingIconSize?: number;
  size?: ButtonSize;
}

type ButtonSize = 'small' | 'medium' | 'large';

const WarningButton = forwardRef<HTMLButtonElement, WarningButtonProps>((props, ref) => {
  const baseProps = {
    ...props,
    buttonLoaderColor: 'red' as ButtonLoaderColors,
    styleClassNames,
    variantName: 'warning',
  };

  return <BaseButton {...baseProps} ref={ref} />;
});

export default WarningButton;
